// File: src/features/long-press/LongPressIndicator.tsx
import React from 'react';

interface LongPressIndicatorProps {
  isVisible: boolean;
  progress: number; // 0 to 1
}

const LongPressIndicator: React.FC<LongPressIndicatorProps> = ({ isVisible, progress }) => {
  if (!isVisible) {
    return null;
  }

  const strokeWidth = 8;
  const radius = 50;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress * circumference;

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-200"
      role="progressbar"
      aria-valuenow={Math.round(progress * 100)}
    >
      {/* Container for the indicator and its label */}
      <div className="flex flex-col items-center justify-center">
        <div className="relative h-32 w-32">
          <svg
            className="h-full w-full"
            viewBox={`0 0 ${radius * 2} ${radius * 2}`}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: 'rotate(-90deg)' }}
          >
            {/* Background Circle */}
            <circle
              stroke="rgba(255, 255, 255, 0.2)"
              cx={radius}
              cy={radius}
              r={normalizedRadius}
              strokeWidth={strokeWidth}
              fill="transparent"
            />
            {/* Progress Arc */}
            <circle
              stroke="white"
              cx={radius}
              cy={radius}
              r={normalizedRadius}
              strokeWidth={strokeWidth}
              strokeDasharray={circumference + ' ' + circumference}
              strokeDashoffset={strokeDashoffset}
              fill="transparent"
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 0.1s linear' }}
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-white text-lg font-bold">
            {Math.round(progress * 100)}%
          </span>
        </div>
        
        {/* NEW: Label added below the circle */}
        <span className="mt-4 text-white text-xl font-semibold tracking-wider animate-pulse">
          Seeking...
        </span>

      </div>
    </div>
  );
};

export default LongPressIndicator;